import { Router } from "../routes"; //Access routing
import Cookies from "js-cookie";
import store from "../store"; // Access redux store data
import { setUiKey, setAlert } from "../store/actions"; //Notification Alert
import "moment-timezone";
import moment from "moment";
import { makeStorageKeyForCookie } from "./common";
import noCarImage from "../public/assets/images/No-Image.jpg";
/*******************
 @purpose : Change File Extension
@Parameter : {fileName, newExt}
@Author : INIC
******************/
export function change_extension(fileName, newExt = "webp") {
  var extension = fileName && fileName.match(/\.([^\./\?]+)($|\?)/)[1];
  if (extension === "svg") {
    return fileName;
  }
  var _tmp;
  return (
    fileName &&
    fileName.substr(
      0,
      ~(_tmp = fileName.lastIndexOf(".")) ? _tmp : fileName.length
    ) +
      "." +
      newExt
  );
}
/*******************
@purpose : Generate Youtube Thmbnail
@Parameter : {url, quality}
@Author : INIC
******************/
export function get_youtube_thumbnail(url, quality) {
  if (url) {
    var video_id,
      result =
        url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/) ||
        url.match(/youtu.be\/(.{11})/);
    if (result) {
      video_id = result.pop();
    }
    if (video_id) {
      if (typeof quality == "undefined") {
        quality = "high";
      }
      var quality_key = "maxresdefault"; // Max quality
      if (quality == "low") {
        quality_key = "sddefault";
      } else if (quality == "medium") {
        quality_key = "mqdefault";
      } else if (quality == "high") {
        quality_key = "hqdefault";
      }
      return (
        "https://img.youtube.com/vi/" + video_id + "/" + quality_key + ".jpg"
      );
    }
  }
  return "";
}
/*******************
 @purpose : Check Number Odd/Even
 @Parameter : {number}
@Author : INIC
******************/
export function is_odd_nuber(number) {
  return Number(number) % 2 == 0;
}
/*******************
 @purpose : Change/Replace Link
 @Parameter : {url}
 @Author : INIC
 ******************/
export function replace_link(url) {
  if (url) {
    var baseUrlPattern = /^https?:\/\/[a-z\:0-9.]+/;
    var result = "";
    var match = baseUrlPattern.exec(url);
    if (match != null) {
      result = match[0];
    }
    if (result.length > 0) {
      url = url.replace(result, "");
    }
    return url;
  }
  return "/error";
}
/*******************
 @purpose :  Next.Js Route Replace Change
 @Parameter : {link, is_scroll_top}
 @Author : INIC
 ******************/
export function on_route_replace_change(link, is_scroll_top = true) {
  link = replace_link(link);
  if (link && link !== "#") {
    Router.pushRoute(link).then(() => is_scroll_top && window.scrollTo(0, 0));
  }
}
/*******************
 @purpose :  Next.Js Route Change
 @Parameter : {path, slug, is_scroll_top}
 @Author : INIC
 ******************/
export function on_route_change(path, slug, is_scroll_top = true) {
  if (slug) {
    Router.pushRoute(path, { slug: slug }).then(
      () => is_scroll_top && window.scrollTo(0, 0)
    );
  } else {
    Router.pushRoute(path).then(() => is_scroll_top && window.scrollTo(0, 0));
  }
}
/*******************
   @purpose :  Filter Data From Array
   @Parameter : {filter, data}
   @Author : INIC
   ******************/
export function real_text_filter(filter, data) {
  if (!filter) {
    return data;
  }
  const lowercasedFilter = filter.toLowerCase();
  return data.filter((item) => {
    return Object.keys(item).some((key) =>
      item[key].toLowerCase().includes(lowercasedFilter)
    );
  });
}
/*******************
   @purpose :  Parse Stringify Query
   @Parameter : {queryString}
   @Author : INIC
   ******************/
export function parse_query(queryString) {
  var query = {};
  var pairs = (
    queryString[0] === "?" ? queryString.substr(1) : queryString
  ).split("&");
  for (let pair of pairs) {
    let new_pair = pair.split("=");
    if (new_pair[0] === "") continue;
    query[decodeURIComponent(new_pair[0])] = decodeURIComponent(
      new_pair[1] || ""
    );
  }
  return query;
}

/*******************
   @purpose :  Get URL Data Type
   @Parameter : {path, type}
   @Author : INIC
   ******************/
export function get_host_url_data(path, type) {
  if (path) {
    let my_url = new URL(path);
    if (type) {
      return my_url[type];
    }
    return my_url;
  }
  return "";
}
/*******************
   @purpose : Get Cookie
   @Parameter : {name}
   @Author : INIC
   ******************/
export function get_cookie(name) {
  if (name) {
    return Cookies.get(name);
  }
  return "";
}
/*******************
   @purpose : Timezone of the currently selected rental location
   @Author : INIC
   ******************/
export const getLocationTimezone = () => {
  const cityName = get_cookie("selectedCityName") || "";
  return cityName.toLowerCase().includes("miami")
    ? "America/New_York"
    : "America/Los_Angeles";
};
/*******************
   @purpose : Today's date ("YYYY-MM-DD") in the selected location's timezone
   @Author : INIC
   ******************/
export const getLocationToday = () =>
  moment().tz(getLocationTimezone()).format("YYYY-MM-DD");
/*******************
   @purpose : Set Cookie
   @Parameter : {name, value}
   @Author : INIC
   ******************/
export function set_cookie(name, value, days = 50000) {
  if (name) {
    // expires after= 50000 days
    Cookies.set(name, value, { expires: days });
  }
}
/*******************
   @purpose : Remove Cookie
   @Parameter : {name}
   @Author : INIC
   ******************/
export function remove_cookie(name) {
  if (name) {
    Cookies.remove(name);
  }
}

const USER_INFO_STORAGE_KEY = "user_info";

export function set_user_info_storage(userInfo) {
  if (typeof window === "undefined") return;
  try {
    if (
      userInfo &&
      typeof userInfo === "object" &&
      Object.keys(userInfo).length > 0
    ) {
      localStorage.setItem(USER_INFO_STORAGE_KEY, JSON.stringify(userInfo));
    } else {
      localStorage.removeItem(USER_INFO_STORAGE_KEY);
    }
  } catch (e) {}
}

export function get_user_info_storage() {
  if (typeof window === "undefined") return "";
  try {
    const stored = localStorage.getItem(USER_INFO_STORAGE_KEY);
    return stored ? JSON.parse(stored) : "";
  } catch (e) {
    return "";
  }
}

const KEEP_COOKIES_ON_LOGOUT = [
  "cookieConsent",
  "XSRF-TOKEN",
  "currentLocationId",
  "selectedLocationDisplay",
  "selectedCityName",
  "cityStateSlug",
];
const KEEP_COOKIE_PREFIXES_ON_LOGOUT = ["_ga", "_gid", "_gcl_", "_fbp", "__stripe_"];

/*******************
   @purpose : Clear all browser storage on logout except allowlisted cookies
   @Parameter : {}
   ******************/
export function clear_client_storage() {
  if (typeof window === "undefined") return;
  Object.keys(Cookies.get()).forEach((name) => {
    const keep =
      KEEP_COOKIES_ON_LOGOUT.includes(name) ||
      KEEP_COOKIE_PREFIXES_ON_LOGOUT.some((prefix) => name.startsWith(prefix));
    if (!keep) {
      Cookies.remove(name);
    }
  });
  try {
    localStorage.clear();
  } catch (e) {}
  try {
    sessionStorage.clear();
  } catch (e) {}
}

/*******************
   @purpose : Remove Array Element
   @Parameter : {arr, item}
@Author : INIC
******************/
export function array_remove_index_by_value(arr, item) {
  for (var i = arr.length; i--; ) {
    if (arr[i] === item) {
      arr.splice(i, 1);
    }
  }
  return arr;
}
/*******************
 @purpose : Save Post On Cookie
 @Parameter : {post_id}
 @Author : INIC
******************/
export function save_post_on_cookie(post_id) {
  let saved_post_id = get_cookie("saved_post_id");
  if (post_id) {
    if (saved_post_id) {
      saved_post_id = JSON.parse(saved_post_id);
      let is_exist = saved_post_id.includes(post_id);
      if (is_exist) {
        saved_post_id = array_remove_index_by_value(saved_post_id, post_id);
        saved_post_id = JSON.stringify(saved_post_id);
        store.dispatch(setAlert("Bookmark removed successfully", "info", 5000));
      } else {
        saved_post_id.push(post_id);
        saved_post_id = JSON.stringify(saved_post_id);
        store.dispatch(
          setAlert("Bookmark saved successfully", "success", 5000)
        );
      }
    } else {
      saved_post_id = [];
      saved_post_id.push(post_id);
      saved_post_id = JSON.stringify(saved_post_id);

      store.dispatch(setAlert("Bookmark saved successfully", "success", 5000));
    }
  }
  store.dispatch(setUiKey("saved_post_id", saved_post_id));
  set_cookie("saved_post_id", saved_post_id);
}
/*******************
   @purpose : Ganarate File Base64 Image
   @Parameter : {file}
   @Author : INIC
   ******************/
export function get_base_64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

/*******************
   @purpose : string to lowercase
   @Parameter : {string}
   @Author : INIC
   ******************/
export function strToLowerCase(str) {
  return str?.toLowerCase();
}

/*******************
   @purpose : replace space with hypen
   @Parameter : {string}
   @Author : INIC
   ******************/
export function replaceSpaceWithHypenToLowercase(str) {
  return str.trim().replace(/\s+/g, "-").toLowerCase();
}

/*******************
  @purpose : seprate firstname, lastname from name
  @Parameter : {fileName, newExt}
  @Author : INIC
  ******************/
export function getNames(name) {
  let data = {
    firstName: name.split(" ")[0],
    lastName: name.split(" ")[1],
  };

  return data;
}

export const metaTags = {
  title: "Exotic Car Rental - Rent An Exotic Car LAX",
  keywords:
    "rent exotic cars, exotic car rental Los Angeles, exotic car rental near me, LA exotic car rental",
  description:
    "LA's #1 Exotic Car Rental Agency - Falcon Car Rental in Los Angeles offers an exclusive fleet of  super exotic and  super sports vehicles such as Lamborghini, Ferrari, McLaren, Rolls Royce and Bentley. Designed to exceed your expectations, we deliver a first-class service for your lifestyle. Rent today!",
  canonical: "https://www.falconcarrental.com",
  page_schema:
    '{\r\n                  "@context": "http://www.schema.org",\r\n                  "@type": "AutoRental",\r\n                  "name": "Falcon Car Rental",\r\n                  "url": "https://www.falconcarrental.com", "sameAs": [\r\n                  "https://www.youtube.com/channel/UCH7rLPw2Wn31SWXs3D8OdkQ", "https://www.instagram.com/falcon_lifestyle/", "https://www.facebook.com/falconlifestyle"],\r\n                  "logo": "https://www.falconcarrental.com/img/logo-black.png", "image": "https://www.falconcarrental.com/uploads/Lamborghini%20Aventador%20SV%20Roadster%20Rental%207-80797.jpg", "description": "Falcon Luxury and Exotic Car Rental in Los Angeles offers an exclusive fleet of elite, ultra-luxury vehicles such as Lamborghini, Rolls Royce and Ferrari. Designed to exceed your needs, we deliver a first-class service for your lifestyle. Rent today!",\r\n                   "address": {\r\n                   "@type": "PostalAddress",\r\n                   "streetAddress": "499 North Canon Drive",\r\n                   "addressLocality": "Beverly Hills",\r\n                   "addressRegion": "CA",\r\n                   "postalCode": "90210",\r\n                   "addressCountry": "USA"\r\n                   },\r\n                   "geo": {\r\n                   "@type": "GeoCoordinates",\r\n                   "latitude": "34.0720374",\r\n                   "longitude": "-118.4047911"\r\n                   },\r\n                   "openingHours": "Mo, Tu, We, Th, Fr 08:00-20:00 Sa, Su 08:00-18:00",\r\n                   "contactPoint": {\r\n                   "@type": "ContactPoint",\r\n                   "telephone": "+1-310-887-7005",\r\n                   "contactType": "Sales"\r\n                   }\r\n                   }',
};

export const loginMetaTags = {
  title: "login",
  keywords:
    "rent exotic cars, exotic car rental Los Angeles, exotic car rental near me, LA exotic car rental",
  description:
    "LA's #1 Exotic Car Rental Agency - Falcon Car Rental in Los Angeles offers an exclusive fleet of  super exotic and  super sports vehicles such as Lamborghini, Ferrari, McLaren, Rolls Royce and Bentley. Designed to exceed your expectations, we deliver a first-class service for your lifestyle. Rent today!",
  canonical: "https://www.falconcarrental.com/login",
};

export const personalDetailsMetaTags = {
  title: "Personal Details",
  keywords: "",
  description: "",
  canonical: "",
};

export const faqsMetaTags = {
  title: "FAQs",
  keywords: "",
  description: "",
  canonical: "",
};

export const blogMetaTags = {
  title: "Falcon Car Rental Blog, Article & News",
  keywords:
    "rent exotic cars, exotic car rental Los Angeles, exotic car rental near me, LA exotic car rental",
  description:
    "Falcon Car Rental Blog - Read our blog to learn more about all of our luxury and exotic car rentals.",
  canonical: "https://www.falconcarrental.com/blog",
  page_schema:
    '{\r\n                  "@context": "http://www.schema.org",\r\n                  "@type": "AutoRental",\r\n                  "name": "Falcon Car Rental",\r\n                  "url": "https://www.falconcarrental.com", "sameAs": [\r\n                  "https://www.youtube.com/channel/UCH7rLPw2Wn31SWXs3D8OdkQ", "https://www.instagram.com/falcon_lifestyle/", "https://www.facebook.com/falconlifestyle"],\r\n                  "logo": "https://www.falconcarrental.com/img/logo-black.png", "image": "https://www.falconcarrental.com/uploads/Lamborghini%20Aventador%20SV%20Roadster%20Rental%207-80797.jpg", "description": "Falcon Luxury and Exotic Car Rental in Los Angeles offers an exclusive fleet of elite, ultra-luxury vehicles such as Lamborghini, Rolls Royce and Ferrari. Designed to exceed your needs, we deliver a first-class service for your lifestyle. Rent today!",\r\n                   "address": {\r\n                   "@type": "PostalAddress",\r\n                   "streetAddress": "499 North Canon Drive",\r\n                   "addressLocality": "Beverly Hills",\r\n                   "addressRegion": "CA",\r\n                   "postalCode": "90210",\r\n                   "addressCountry": "USA"\r\n                   },\r\n                   "geo": {\r\n                   "@type": "GeoCoordinates",\r\n                   "latitude": "34.0720374",\r\n                   "longitude": "-118.4047911"\r\n                   },\r\n                   "openingHours": "Mo, Tu, We, Th, Fr 08:00-20:00 Sa, Su 08:00-18:00",\r\n                   "contactPoint": {\r\n                   "@type": "ContactPoint",\r\n                   "telephone": "+1-310-887-7005",\r\n                   "contactType": "Sales"\r\n                   }\r\n                   }',
};

export const tripMetaTags = {
  title: "My Trips",
  keywords:
    "rent exotic cars, exotic car rental Los Angeles, exotic car rental near me, LA exotic car rental",
  description:
    "Falcon Car Rental Blog - Read our blog to learn more about all of our luxury and exotic car rentals.",
  canonical: "https://www.falconcarrental.com/blog",
  page_schema:
    '{\r\n                  "@context": "http://www.schema.org",\r\n                  "@type": "AutoRental",\r\n                  "name": "Falcon Car Rental",\r\n                  "url": "https://www.falconcarrental.com", "sameAs": [\r\n                  "https://www.youtube.com/channel/UCH7rLPw2Wn31SWXs3D8OdkQ", "https://www.instagram.com/falcon_lifestyle/", "https://www.facebook.com/falconlifestyle"],\r\n                  "logo": "https://www.falconcarrental.com/img/logo-black.png", "image": "https://www.falconcarrental.com/uploads/Lamborghini%20Aventador%20SV%20Roadster%20Rental%207-80797.jpg", "description": "Falcon Luxury and Exotic Car Rental in Los Angeles offers an exclusive fleet of elite, ultra-luxury vehicles such as Lamborghini, Rolls Royce and Ferrari. Designed to exceed your needs, we deliver a first-class service for your lifestyle. Rent today!",\r\n                   "address": {\r\n                   "@type": "PostalAddress",\r\n                   "streetAddress": "499 North Canon Drive",\r\n                   "addressLocality": "Beverly Hills",\r\n                   "addressRegion": "CA",\r\n                   "postalCode": "90210",\r\n                   "addressCountry": "USA"\r\n                   },\r\n                   "geo": {\r\n                   "@type": "GeoCoordinates",\r\n                   "latitude": "34.0720374",\r\n                   "longitude": "-118.4047911"\r\n                   },\r\n                   "openingHours": "Mo, Tu, We, Th, Fr 08:00-20:00 Sa, Su 08:00-18:00",\r\n                   "contactPoint": {\r\n                   "@type": "ContactPoint",\r\n                   "telephone": "+1-310-887-7005",\r\n                   "contactType": "Sales"\r\n                   }\r\n                   }',
};

// make country data
export const makeCountryData = (countries) => {
  return countries?.map((country) => ({
    label: country.name,
    value: country.phonecode,
    ...country,
  }));
};

// make states data
export const makeStatesData = (states) => {
  return states.map((state) => ({
    label: state.name,
    value: state.id,
    ...state,
  }));
};

//check and add leading zero to number
export const padLeadingZeros = (num, size) => {
  var s = num + "";
  while (s.length < size) s = "0" + s;
  return s;
};

/******************* 
@purpose : Used for show default  image onerror
@Parameter : {} 
@Author : INIC
******************/

export const setDefaultCarImage = (e) => {
  e.currentTarget.src = noCarImage;
  e.currentTarget.onerror = null;
};

//check date and seperates
export const getDate = (dateGiven) => {
  let date = moment.utc(dateGiven);

  return {
    day: date.date(),
    month: date.month() + 1,
    year: date.year(),
  };
};

/*******************
   @purpose : fitler hour
   @Parameter : {str}
   @Author : INIC
   ******************/
export function filterHour(hour) {
  if (hour > 0) {
    if (hour > 1) {
      return " and " + hour + " hours";
    } else {
      return " and " + hour + " hour";
    }
  }
  return "";
}

/*******************
 @purpose : Date format for my trips
 @Parameter : {date} // 2019-12-09 19:00 PM
 @Author : INIC
 ******************/
export function dateFormatForMytrips(date) {
  if (date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const arr = date.split(" ");
    const dateString = arr["0"];
    let time = parseInt(arr["1"].split(":")[0]);
    if (time < 12) {
      time = time + ":00 AM";
    } else {
      if (time > 12) {
        time = time - 12;
      }
      time = time + ":00 PM";
    }

    const selectedArr = dateString?.split("-");
    let year = selectedArr[0];
    let month = parseInt(selectedArr[1], 10) - 1;
    let day = parseInt(selectedArr[2], 10);
    let utcDate = new Date(year, month, day);

    const dateObj = new Date(utcDate);

    return (
      monthNames[dateObj.getMonth()] +
      " " +
      dateObj.getDate() +
      ", " +
      dateObj.getFullYear() +
      " at " +
      time
    );
  } else {
    return "";
  }
}

/*******************
 @purpose : Date format for my trips
 @Parameter : {date} // 2019-12-09 19:00 PM
 @Author : INIC
 ******************/
export function dateFormatForStep2(date, flag = "") {
  if (date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const arr = date.split(" ");
    const dateString = arr["0"];
    let time = parseInt(arr["1"].split(":")[0]);
    if (flag) {
      if (time < 12) {
        time = time + ":00 AM";
      } else {
        if (time > 12) {
          time = time - 12;
        }
        time = time + ":00 PM";
      }
    } else {
      if (time < 12) {
        time = time + ":00 AM";
      } else {
        if (time > 12) {
          time = time - 12;
        }
        time = time + ":00 PM";
      }
    }

    const selectedArr = dateString?.split("-");
    let year = selectedArr[0];
    let month = parseInt(selectedArr[1], 10) - 1;
    let day = parseInt(selectedArr[2], 10);
    let utcDate = new Date(year, month, day);

    const dateObj = new Date(utcDate);

    let returnStr = "";
    if (flag) {
      returnStr =
        monthNames[dateObj.getMonth()] +
        " " +
        dateObj.getDate() +
        ", " +
        dateObj.getFullYear() +
        " at " +
        time;
    } else {
      returnStr =
        monthNames[dateObj.getMonth()] +
        " " +
        dateObj.getDate() +
        ", " +
        dateObj.getFullYear() +
        " at " +
        time;
    }
    return returnStr;
  } else {
    return "";
  }
}

/*******************
@purpose : Date format
@Parameter : {date} // 2019-12-09 19:00 PM
@Author : INIC
******************/
export function getDateObject(date) {
  let dateObj = moment(date);
  return {
    day: dateObj.date(),
    month: dateObj.month() + 1,
    year: dateObj.year(),
  };
}

/*******************
@purpose : check authentication token
@Parameter : {}
@Author : INIC
******************/
export function checkToken() {
  let token = get_cookie("token");
  return token ? true : false;
}

/*******************
@purpose : conver to moment object
@Parameter : {}
@Author : INIC
******************/
export function getMomentDate(d, m, y) {
  if (m.toString().length === 1) {
    m = "0" + m.toString();
  }
  if (d.toString().length === 1) {
    d = "0" + d.toString();
  }
  return d && m && y && new Date(`${d}/${m.toString()}/${y}`);
}

/*******************
@purpose : conver to moment object
@Parameter : {}
@Author : INIC
****************/
export function momentFormatter(date, format) {
  let dateToformat = date?.replace(/[AaPp][Mm]+/g, "");
  return moment(dateToformat).format(format);
}

/*******************
@purpose : to get class for uploaded document status as pending/approved/decline
@Parameter : {status}
@Author : INIC
******************/
export function getDocStatus(status) {
  let obj = "";
  switch (status) {
    case "Pending":
      obj = {
        status: "pending",
        class: "is-pending",
      };
      break;

    case "Approved":
      obj = {
        status: "approved",
        class: "is-approved",
      };
      break;

    case "Decline":
      obj = {
        status: "decline",
        class: "is-decline",
      };
      break;
    default:
      break;
  }
  return obj;
}

export function minimumDayErrorMessage(day) {
  let text = "1 day";
  if (day > 1) {
    text = day + " day";
  }
  return "A " + text + " minimum rental required";
}

export const floatAndRound = (val) => {
  let roundedVal = parseFloat(val).toFixed(2);
  return roundedVal;
};

export const b64toBlob = (b64Data, sliceSize, fileName = "media") => {
  let block = b64Data?.split(";");
  let contentType = block[0].split(":")[1];
  let realData = block[1].split(",")[1];
  sliceSize = sliceSize || 512;
  let byteCharacters = atob(realData);
  let byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);
    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  let newBlob = new Blob(byteArrays, { type: contentType });
  newBlob.name = fileName + "." + contentType.split("/")[1];
  return new File([newBlob], newBlob.name, { type: newBlob.type });
};

export const floatAndRoundOff = (val) => {
  return Math.round(parseFloat(val).toFixed(2) * 100);
};

// Used to convert HTML entity to normal string.
const decodeHtml = (string) => {
  let html;
  if (typeof window !== "undefined") {
    html = window.document.createElement("textarea");
    html.innerHTML = string;
  }
  return html?.value;
};

export function focusAndOpenKeyboard(el, timeout) {
  if (!timeout) {
    timeout = 100;
  }
  if (el) {
    // Align temp input element approximately where the input element is
    // so the cursor doesn't jump around
    var __tempEl__ = document.createElement("input");
    __tempEl__.style.position = "absolute";
    __tempEl__.style.top = el.offsetTop + 7 + "px";
    __tempEl__.style.left = el.offsetLeft + "px";
    __tempEl__.style.height = 0;
    __tempEl__.style.opacity = 0;
    // Put this temp element as a child of the page <body> and focus on it
    document.body.appendChild(__tempEl__);
    __tempEl__.focus();

    // The keyboard is open. Now do a delayed focus on the target element
    setTimeout(function () {
      el.focus();
      el.click();
      // Remove the temp element
      document.body.removeChild(__tempEl__);
    }, timeout);
  }
}
export default decodeHtml;

export const getCountryUS = (options) => {
  let countryData = options?.filter(
    (country) => country.name == "United States"
  );
  if (countryData) {
    return countryData[0];
  } else {
    return {
      id: "eyJpdiI6IkYrYTUrMWFsaGM3QnIwWEZ2elZRclE9PSIsInZhbHVlIjoiWkQzV2hxZnU4R1c1YUxtRzFpOFJNdz09IiwibWFjIjoiZTA2YWVlZTRmNDY1MWRhZmQ1NGZiMTkzMTFjYmI3MGU5MDJlMjVkM2E5ZDExMzdjOTc0ODU3OGUyZjdmOGE5OCIsInRhZyI6IiJ9",
      sortname: "US",
      name: "United States",
      phonecode: 1,
    };
  }
};

// Set hide drive now section for week if date is greater than 2 days
export const hideDriveNow = (date) => {
  const storageKey = makeStorageKeyForCookie("hdn");
  const selectedDateUnixTime = Date.parse(date + " 00:00:00 GMT");
  const currentUnixTime = Date.parse(getLocationToday().replace(/-/g, "/") + " 00:00:00 GMT");
  const twoDaysInMillisecond = 172800000;
  const timeDiff = selectedDateUnixTime - currentUnixTime;
  if (timeDiff > 0 && timeDiff > twoDaysInMillisecond) {
    set_cookie(storageKey, "yes", 7);
  }
};

// remove front zero from phone no
export const removeFrontZeroFromPhoneNo = (phoneNo) => {
  if (phoneNo?.["0"] === "0") {
    return phoneNo.slice(1);
  }
  return phoneNo;
};

// for capitalize first word
export function capitalizeFirstWord(sentence) {
  // Split the sentence into words
  let words = sentence?.split(" ");

  // Capitalize the first character of the first word and convert the rest to lowercase
  let firstWord =
    words?.[0]?.charAt(0)?.toUpperCase() + words?.[0]?.slice(1)?.toLowerCase();

  // Join the first word with the rest of the words
  let capitalizedSentence =
    firstWord + " " + words?.slice(1)?.join(" ")?.toLowerCase();
  return capitalizedSentence;
}
